import React from 'react';
import styled from 'astroturf/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import $image_url from 'js/utils/image_url';
import SignUpButton from '../shared/SignUpButton';

export interface Props {
  name: string;
  numCourses: number;
  showSignUpButton: boolean;
}

const Title = styled.h1`
  margin-top: 56px;
  margin-bottom: 24px;
  font-weight: normal;
  font-size: 44px;
  letter-spacing: -0.015em;
`;

const ListItem = styled.li`
  @import '../shared/mixins.scss';
  @include subheadRegular();
  margin-bottom: 16px;
`;

const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 40px;
`;

const Header: React.FunctionComponent<Props> = ({
  name,
  numCourses,
  showSignUpButton,
}) => {
  const valueProps = [
    `Watch ${numCourses} Courses taught by leading Scholars`,
    'Learn quickly in 30-90 minutes',
    'Get unlimited access to all Courses',
  ];

  return (
    <>
      <img
        src={$image_url('checkout/academia-premium-logo.png')}
        height={16}
        alt="Academia Premium"
      />
      <Title>{`Explore our ${name} Courses`}</Title>
      <ul className="fa-ul">
        {valueProps.map((item, index) => (
          <ListItem key={index}>
            <span className="fa-li">
              <FontAwesomeIcon icon={faCheck} />
            </span>
            {item}
          </ListItem>
        ))}
      </ul>
      {showSignUpButton && (
        <ButtonContainer>
          <SignUpButton />
        </ButtonContainer>
      )}
    </>
  );
};

export default Header;
